import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import BtnSubmit from "../../../../Shared/Buttons/BtnSubmit";
import BtnWhiteBlackBorderBigSize from "../../../../Shared/Buttons/BtnWhiteBlackBorderBigSize";
import { reportAnalytics } from "../../saleJetBlockSlice";
import { isOrgEmployeeLogin } from 'app/Components/Block/OTPLoginBlock/Assets/variables';
import { getOrgBenefitsAllocations } from '../../saleBlockAsyncThunk';
import { setMessageData } from 'app/Components/Page/OrgEmployeeFamilySalePage/OrgEmployeeFamilySaleSlice';
import { messageData } from 'app/Components/Page/OrganizationEmloyeePage/Conatant';
const CellularSaleFooter = (props) => {

  const isOrgEmployee = isOrgEmployeeLogin(props._authentication);
  if(!props.isDisplay){
    return null;
  }


  const onAddLineClick = async (action) => {
    if(isOrgEmployee){
      const remainingBenefits = await props.getOrgBenefitsAllocations({productsDescription: null, saleType: props.saleType,mode:'addLine'});
      if(remainingBenefits.payload <= props.cellularSettingsList.length){
        props.setMessageData(messageData.OverBenefits);
        return;
      }
    }
    action();
  }

  return (
    <>
      <footer className="sale-jet-footer-two-btns">
        <div className={`sale-footer-wrapper`}>
          <div className="error">{props.errorText}</div>
          <div className="buttons-wrapper">
            {props.rightBtn && props.rightBtn.isDisplay &&
              <div className="btn-right">
                <BtnWhiteBlackBorderBigSize
                  text={props.rightBtn.text}
                  onclick={() => onAddLineClick(props.rightBtn.onclick)}
                />
              </div>
            }
            <div className="btn-left">
              <BtnSubmit
                isBusiness={false}
                text={props.leftBtn.text}
                onclick={props.leftBtn.onclick}
                formid={props.formid}
                isDisplayArrows={false}
              />
            </div>
          </div>
          {props.bottomLink && props.bottomLink.isDisplay && (
            <div className="link-wrapper">
              <a href="#" onClick={() => onAddLineClick(props.bottomLink.onclick)}>
                {props.bottomLink.text}
              </a>
            </div>
          )}
        </div>
      </footer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    orgProductDescription: state.orgEmployeeFamilySale?.benefitsAllocations,
    _authentication: state.authentication,
    cellularSettingsList: state.saleJetBlock.cellular.cellularSettingsList,
  };
};

const mapDispatchToProps = {
  reportAnalytics,
  setMessageData,
  getOrgBenefitsAllocations
};

export default connect(mapStateToProps, mapDispatchToProps)(CellularSaleFooter);
